export default "__VITE_ASSET__D$L_ICzn__"